import React from 'react';
import { SearchBox as HeadlessSearchBox } from '@coveo/headless';
import { FunctionComponent, useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

import './index.scss';
import { FaSearch } from 'react-icons/fa';
import { Navigate, useLocation } from 'react-router-dom';

export interface SubscriptionSearchBoxProps {
  controller: HeadlessSearchBox;
}

export const SubscriptionSearchBox: FunctionComponent<SubscriptionSearchBoxProps> = (props) => {
  const { controller } = props;
  const [navigateSearch, setNavigateSearch] = useState(false);
  const [state, setState] = useState(controller.state);
  const loc = useLocation();

  const isEnterKey = (e: React.KeyboardEvent<HTMLInputElement>) => e.key === 'Enter';

  useEffect(() => {
    const unsubscribe = controller.subscribe(() => setState(controller.state));
    return () => unsubscribe();
  }, [controller]);

  const navigateToSearch = () => {
    if (loc.pathname !== '/subscriptions/standards') {
      setNavigateSearch(true);
    } else {
      controller.submit();
    }
  };

  return (
    <div className="searchFieldWrapper">
      <Autocomplete
        className="siteSearchField"
        inputValue={state.value}
        onInputChange={(_: any, newInputValue: string) => {
          controller.updateText(newInputValue);
        }}
        onKeyDown={(e: any) => isEnterKey(e) && navigateToSearch()}
        options={state.suggestions}
        getOptionLabel={(option: any) => {
          return typeof option === 'object' ? option.rawValue : option;
        }}
        slotProps={{
          paper: {
            sx: {
              '& .MuiAutocomplete-option': {
                fontSize: '2rem',
              },
              '& .MuiAutocomplete-option.Mui-focused, \
              & .MuiAutocomplete-option.Mui-focusVisible, \
              & .MuiAutocomplete-option[aria-selected="true"], \
              & .MuiAutocomplete-option:hover': {
                backgroundColor: 'rgba(0,0,0,0.04) !important',
                color: 'rgba(0,0,0,0.87) !important',
              },
            },
          },
        }}
        renderOption={(props, option: any) => {
          return (
            <li {...props}>
              <div dangerouslySetInnerHTML={{ __html: option.highlightedValue }}></div>
            </li>
          );
        }}
        freeSolo
        renderInput={(params: any) => (
          <TextField
            {...params}
            placeholder="Search Standards..."
            className="no-border-box"
            variant="outlined"
            size="small"
          />
        )}
      />
      <button className="SearchIcon" onClick={() => navigateToSearch()}>
        <FaSearch />
      </button>
      {navigateSearch ? <Navigate to={`/subscriptions/standards${loc.hash.slice(1)}`} /> : <></>}
    </div>
  );
};

export default SubscriptionSearchBox;
